import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import '../../scss/popups/reset_password.scss';

import closeIcon from '../../images/popups/upload/closeicon.png';
import eyeIcon from '../../images/login/eyeicon.png';

function ResetPassword(props) {
    const {show, handleClose, resetPasswordApiCall, errormessage} = props;
    const [passwordDetails, setPasswordDetails] = useState({NewPassword: null, ConfirmPassword: null});
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);

    const handleNewPassword = (value) => {
        setPasswordDetails({
            ...passwordDetails,
            NewPassword: value
        })
    }

    const handleConfirmPassword = (value) => {
        setPasswordDetails({
            ...passwordDetails,
            ConfirmPassword: value
        })
    }

    const handleSave = () => {
        handleClose();
        resetPasswordApiCall(passwordDetails);
    }

    const handleNewPasswordShow = () => {
        setShowNewPassword(!showNewPassword);
    }

    const handleConfirmPasswordShow = () => {
        setShowConfirmPassword(!showConfirmPassword)
    }

    return (
        <>
            <Modal
                show={show}
                onHide={handleClose} className='reset-password-popup'
                centered>
                <Modal.Body className='reset-password-body'>
                    <p className="error-message">{errormessage}</p>
                    <div className='close-icon'>
                        <img src={closeIcon} onClick={handleClose}/>
                    </div>
                    <div className='reset-password-popup-header'>Reset Password</div>
                    <div className='reset-password-popup-body'>
                        <div className='new-password-container'>
                            <label>New Password</label>
                            <div className='password-input-field'>
                                <input type={showNewPassword ? "text" : "password"} onChange={(e) => handleNewPassword(e.target.value)}
                                maxLength={20}/>
                                <img src={eyeIcon} alt="eye-icon" onClick={handleNewPasswordShow}></img>
                            </div>
                        </div>
                        <div className='confirm-password-container'>
                            <label>Confirm Password</label>
                            <div className='password-input-field'>
                                <input type={showConfirmPassword ? "text" : "password"} onChange={(e) => handleConfirmPassword(e.target.value)}
                                maxLength={20}/>
                                <img src={eyeIcon} alt="eye-icon" onClick={handleConfirmPasswordShow}></img>
                            </div>
                        </div>
                    </div>  
                    <div className='add-button'>
                        <button onClick={handleSave}>Save</button>
                    </div>            
                </Modal.Body>
            </Modal>
        </>
    );
}

export default ResetPassword;